import { Radio, RadioGroup } from "@blueprintjs/core"
import React from "react"
import { withFormController } from "components/Molecules/FormController"
import { DELIVERY_METHODS } from "data/static.items"

const DeliveryType = ({ source, onChange }) => {
  const value = source?.shippingMethod
  return (
    <>
      <h6 className="mt-6">Delivery Type</h6>
      <hr className="mt-0" />
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-6">
          <RadioGroup
            inline
            selectedValue={value}
            onChange={({ target }) =>
              onChange("shippingMethod", (target as any)?.value)
            }
          >
            {DELIVERY_METHODS.map(d => {
              return <Radio key={d?.id} label={d?.name} value={d?.id} />
            })}
          </RadioGroup>
          {/* <StaticSelector items={DELIVERY_METHODS} path="shippingMethod" /> */}
        </div>
      </div>
    </>
  )
}

export default withFormController(DeliveryType)
